import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
export function ApiRiskAssessmentPage() {
  return <DocPageLayout title="Standalone Risk Assessment API" description="Perform risk assessment without processing a payment transaction." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'Risk Assessment'
  }]} sections={[{
    id: 'evaluate-risk',
    title: 'Assess Risk'
  }]} data-id="element-645">
      <h2 id="evaluate-risk" className="text-2xl font-bold text-gray-900 mt-6 mb-4 border-b border-gray-200 pb-2" data-id="element-646">
        Assess Risk
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-647">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-700 mr-2" data-id="element-648">
          POST
        </span>
        <span className="text-gray-600" data-id="element-649">/merchant/</span>
        <span className="text-blue-600" data-id="element-650">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-651">/riskAssessment</span>
      </div>
      <CodeBlock language="JSON" title="Request" code={`{
  "apiOperation": "ASSESS_RISK",
  "order": {
    "amount": "500.00",
    "currency": "USD"
  },
  "sourceOfFunds": {
    "provided": {
      "card": {
        "number": "5123450000000008"
      }
    }
  },
  "customer": {
    "email": "customer@example.com",
    "ipAddress": "203.0.113.50"
  }
}`} data-id="element-652" />
      <CodeBlock language="JSON" title="Response" code={`{
  "result": "SUCCESS",
  "risk": {
    "assessment": "MEDIUM",
    "score": 45,
    "rules": [
      { "name": "HIGH_VALUE_TRANSACTION", "recommendation": "REVIEW" },
      { "name": "NEW_CUSTOMER", "recommendation": "REVIEW" }
    ]
  },
  "response": {
    "gatewayCode": "RISK_ASSESSED",
    "gatewayRecommendation": "REVIEW"
  }
}`} data-id="element-653" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-654">
        Risk Levels
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-655">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-656">
          <thead data-id="element-657">
            <tr className="bg-gray-100" data-id="element-658">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-659">
                Level
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-660">
                Score Range
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-661">
                Recommendation
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-662">
            <tr data-id="element-663">
              <td className="px-4 py-3 font-mono text-xs text-green-600 font-bold" data-id="element-664">
                LOW
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-665">0 – 30</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-666">
                ACCEPT — Proceed with transaction
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-667">
              <td className="px-4 py-3 font-mono text-xs text-amber-600 font-bold" data-id="element-668">
                MEDIUM
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-669">31 – 70</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-670">
                REVIEW — Manual review recommended
              </td>
            </tr>
            <tr data-id="element-671">
              <td className="px-4 py-3 font-mono text-xs text-red-600 font-bold" data-id="element-672">
                HIGH
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-673">71 – 100</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-674">
                REJECT — Decline the transaction
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}